<template>
	<v-container fluid class="pa-4">
		<v-row justify="center">
			<v-col cols="12" md="6">
				<v-card outlined>
					<v-card-title>
						<v-icon left>mdi-account</v-icon>
						Il mio Profilo
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text>
						<v-alert v-if="success" type="success" dense outlined class="mb-4">{{ success }}</v-alert>
						<v-alert v-if="error" type="error" dense outlined class="mb-4">{{ error }}</v-alert>

						<v-text-field
							v-model="form.name"
							label="Nome"
							outlined
							dense
						></v-text-field>
						<v-text-field
							v-model="form.email"
							label="Email"
							outlined
							dense
							disabled
						></v-text-field>
						<v-text-field
							v-model="companyName"
							label="Azienda"
							outlined
							dense
							disabled
						></v-text-field>

						<v-btn color="primary" @click="saveProfile" :loading="saving" class="mr-2">
							Salva
						</v-btn>
					</v-card-text>
				</v-card>

				<!-- Cambio password -->
				<v-card outlined class="mt-4">
					<v-card-title>
						<v-icon left>mdi-lock</v-icon>
						Cambio Password
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text>
						<v-alert v-if="pwSuccess" type="success" dense outlined class="mb-4">{{ pwSuccess }}</v-alert>
						<v-alert v-if="pwError" type="error" dense outlined class="mb-4">{{ pwError }}</v-alert>

						<v-form ref="pwForm" lazy-validation>
							<v-text-field
								v-model="pwForm.current_password"
								label="Password attuale"
								:type="showCurrent ? 'text' : 'password'"
								:append-icon="showCurrent ? 'mdi-eye-off' : 'mdi-eye'"
								@click:append="showCurrent = !showCurrent"
								:rules="[v => !!v || 'Obbligatorio']"
								outlined
								dense
							></v-text-field>
							<v-text-field
								v-model="pwForm.password"
								label="Nuova password"
								:type="showNew ? 'text' : 'password'"
								:append-icon="showNew ? 'mdi-eye-off' : 'mdi-eye'"
								@click:append="showNew = !showNew"
								:rules="passwordRules"
								outlined
								dense
							></v-text-field>
							<v-text-field
								v-model="pwForm.password_confirmation"
								label="Conferma nuova password"
								:type="showConfirm ? 'text' : 'password'"
								:append-icon="showConfirm ? 'mdi-eye-off' : 'mdi-eye'"
								@click:append="showConfirm = !showConfirm"
								:rules="[v => !!v || 'Obbligatorio', v => v === pwForm.password || 'Le password non coincidono']"
								outlined
								dense
							></v-text-field>
							<portal-password-requirements :password="pwForm.password" :policy="policy"></portal-password-requirements>
							<v-btn color="warning" @click="changePassword" :loading="changingPw">
								Cambia Password
							</v-btn>
						</v-form>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import PortalPasswordRequirements from './PortalPasswordRequirements'
import { DEFAULT_PORTAL_PASSWORD_POLICY, buildPasswordRules, fetchPortalPasswordPolicy, firstValidationError } from './portalPasswordPolicy'

export default {
	name: 'PortalProfile',
	components: {
		PortalPasswordRequirements
	},
	data() {
		return {
			form: { name: '', email: '' },
			companyName: '',
			saving: false,
			success: null,
			error: null,
			// Password change
			pwForm: { current_password: '', password: '', password_confirmation: '' },
			showCurrent: false,
			showNew: false,
			showConfirm: false,
			changingPw: false,
			pwSuccess: null,
			pwError: null,
			policy: Object.assign({}, DEFAULT_PORTAL_PASSWORD_POLICY)
		}
	},
	computed: {
		passwordRules() {
			return buildPasswordRules(this.policy)
		}
	},
	async created() {
		this.loadProfile()
		this.policy = await fetchPortalPasswordPolicy(this.axios)
	},
	methods: {
		async loadProfile() {
			try {
				const resp = await this.axios.get('portal/profile')
				if (resp.data.success) {
					const data = resp.data.data
					this.form.name = data.user.name
					this.form.email = data.user.email
					this.companyName = data.company ? (data.company.business_name || data.company.name) : ''
				}
			} catch (e) {
				// silenzioso
			}
		},
		async saveProfile() {
			this.saving = true
			this.success = null
			this.error = null
			try {
				const resp = await this.axios.put('portal/profile', { name: this.form.name })
				if (resp.data.success) {
					this.success = 'Profilo aggiornato'
					this.$store.dispatch('PORTAL_FETCH_PROFILE')
				} else {
					this.error = resp.data.message || 'Errore'
				}
			} catch (e) {
				this.error = 'Errore nel salvataggio'
			} finally {
				this.saving = false
			}
		},
		async changePassword() {
			if (!this.$refs.pwForm.validate()) return

			this.changingPw = true
			this.pwSuccess = null
			this.pwError = null

			try {
				// l'errore di validazione e' mostrato nel form
				const resp = await this.axios.post('portal/change-password', this.pwForm, { silentValidation: true })
				if (resp.data.success) {
					this.pwSuccess = 'Password cambiata con successo'
					this.pwForm = { current_password: '', password: '', password_confirmation: '' }
					this.$refs.pwForm.resetValidation()
				} else {
					this.pwError = resp.data.message || 'Errore'
				}
			} catch (e) {
				this.pwError = firstValidationError(e, 'Errore')
			} finally {
				this.changingPw = false
			}
		}
	}
}
</script>
